const toLookupKey = (value) => String(value ?? '').trim().toLowerCase();

export const getFeatureById = (featureId, features) => {
  const key = toLookupKey(featureId);
  return features.find((feature) => toLookupKey(feature?.ID) === key);
};

export const getCustomFieldById = (customFieldId, customFields) => {
  const stringId = String(customFieldId ?? '').trim();
  const numericId = parseInt(stringId, 10);

  return customFields.find((customField) => {
    if (customField?.ID === numericId) {
      return true;
    }

    return String(customField?.ID ?? '').trim() === stringId;
  });
};

export const getConversionById = (conversionId, conversions) => {
  const key = toLookupKey(conversionId);
  return conversions.find((conversion) => toLookupKey(conversion?.ID) === key);
};
